import React from 'react'
import { createWidgetsBem } from '@om-fe/widgets/dist/common/bem/bem';
import { GeneralIcon } from '@om-fe/widgets/dist/components/icon/general-icon';
import { BemMethod, createBem } from '@om-fe/utils';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { RouteNames } from '@om-fe/core/core/routing/utils';
import Anchor from '@om-fe/core/components/anchor/anchor';

const bem: BemMethod = createWidgetsBem('Menu');
const bemMenuHeader: BemMethod = createWidgetsBem('MenuHeader');
const bemMenuItem: BemMethod = createWidgetsBem('MenuItem');

const bemWidget: BemMethod = createBem('Widget');
const bemMenuContent: BemMethod = createBem('Menu');
const bemMenuContentItem: BemMethod = createBem('MenuItem');

export enum QuickLinkLayout {
    Tab = 'tab',
    Menu = 'menu',
}

interface QuickLinkProps {
    readonly layout: QuickLinkLayout,
}

export const QuickLink = ({
    layout = QuickLinkLayout.Menu,
}: QuickLinkProps) => {
    const { gettext } = useI18NContext()

    return (
        <div className={bem()}>
            <div className={bemMenuHeader()}>
                <span className={bemMenuHeader('Title')}>
                    {gettext('Quick Links')}
                </span>
            </div>
            {layout === QuickLinkLayout.Menu && (
                <div className={bemWidget()}>
                    <ul className={bemMenuContent()}>
                        <li className={bemMenuContentItem()}>
                            <Anchor
                                routeName={RouteNames.bonusOfTheDay}
                                className={bemMenuContentItem('Anchor')}
                            >
                                <span className={bemMenuContentItem('IconWrapper')}>
                                    <GeneralIcon name="gift" />
                                </span>
                                <span className={bemMenuContentItem('Name')}>
                                    <span className={bemMenuContentItem('Text')}>
                                        {gettext('Danas')}
                                    </span>
                                </span>
                            </Anchor>
                        </li>
                    </ul>
                </div>
            )}
            {layout === QuickLinkLayout.Tab && (
                <Anchor
                    routeName={RouteNames.bonusOfTheDay}
                    className={bemMenuContentItem('Anchor')}
                >
                    <div className={bemMenuItem()}>
                        <div className={bemMenuItem('ActionGroup')}>
                            <span className={bemMenuItem('Action')}>
                                <span className={bemMenuItem('ItemIndicator')}>
                                    <GeneralIcon name="gift" />
                                </span>
                                <div className={bemMenuItem('ItemContent')}>
                                    <span className={bemMenuItem('ItemText')}>
                                        {gettext('Danas')}
                                    </span>
                                </div>
                            </span>
                        </div>
                    </div>
                </Anchor>
            )}
        </div>
    )
}